// extracted by mini-css-extract-plugin
module.exports = {"section":"Sect3_section__aF7tV","div":"Sect3_div__3bDg-","wireframeDiv":"Sect3_wireframeDiv__3De3O","wireframe":"Sect3_wireframe__SLoLg"};